<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="page_i"></a><a id="page_ii"><img alt="Image" src="images/chapimage.jpg"/></a></p><a id="page_ii">
<p class="center"><em>After Elise fell asleep, Rose crept to the garden.<br/>Ombrine had ordered her to stay out of it—<br/>especially at night—and promised severe<br/>punishment if she disobeyed</em>.</p>
<p class="noindent"><span class="big">B</span>ut it was in this garden she had last seen her mother, and had heard the joyous news that her father was coming home.</p>
<p class="indent">“<em>You are loved,”</em> the roses whispered.</p>
<p class="indent">“I <em>was</em> loved: she said brokenly. “But now they’re gone:’ She began to cry again.</p>
<p class="indent">Moonlight gleamed around Rose like her mother’s sheltering arms, and after a time, she fell into a deep, heavy sleep.</p>
<p class="indent">And in that sleep, a glowing hand cupped a shimmering white mouth pressed against her ear.</p>
<p class="indent">A voice whispered, <em>‘Alas, daughter of she who made the wish, you still must walk through the shadows until you see the light. Once you learn the lesson, two broken hearts shall mend.”</em></p>
<p class="indent">Rose slumbered and didn’t hear the voice.</p>
<p class="indent">But her heart heard it.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?a30566be